import React from 'react'

const Section2 = () => {
    return (
        <div>
            <div className="h-10 md:h-3" />

            <div>
                <h2 className="text-[8px] md:text-[24px] font-bold text-[#03897B] -mb-3 ">
                    <span className="text-[#979797]">Section 2 : </span>MANAGEMENT
                </h2>
            </div>
            <div className="h-4 md:h-9" />

            <div className="grid grid-cols-2 md:grid-cols-2 md:gap-6 gap-2">
                {/* Chair Name */}
                <div>
                    <label className="block text-[8px] md:text-[24px] font-bold -mb-1 md:pl-2">Chair Person First Name</label>
                    <input type="text" className="bg-[#D9D9D9] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#D9D9D9] outline-none text-[8px] md:text-[24px] placeholder:text-black font-medium" placeholder="LEWIS" />
                </div>

                {/* Chair Surname */}
                <div>
                    <label className="block text-[8px] md:text-[24px] font-bold -mb-1 md:pl-2">Surname</label>
                    <input type="text" className="bg-[#D9D9D9] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#D9D9D9] outline-none text-[8px] md:text-[24px] placeholder:text-black font-medium" placeholder="CHAUKE" />
                </div>

                {/* Secretary Name */}
                <div>
                    <label className="block text-[8px] md:text-[24px] font-bold -mb-1 md:pl-2">General Secretary First Name</label>
                    <input type="text" className="bg-[#D9D9D9] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#D9D9D9] outline-none text-[8px] md:text-[24px] placeholder:text-black font-medium" placeholder="LEWIS" />
                </div>

                {/* Secretary Surname */}
                <div>
                    <label className="block text-[8px] md:text-[24px] font-bold -mb-1 md:pl-2">Surname</label>
                    <input type="text" className="bg-[#D9D9D9] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#D9D9D9] outline-none text-[8px] md:text-[24px] placeholder:text-black font-medium" placeholder="CHAUKE" />
                </div>

                {/* Email */}
                <div>
                    <label className="block text-[8px] md:text-[24px] font-bold -mb-1 md:pl-2">Email address</label>
                    <input type="text" className="bg-[#D9D9D9] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#D9D9D9] outline-none text-[8px] md:text-[24px] placeholder:text-black font-medium" placeholder="enterpreneur@email.co.za" />
                </div>

                {/* Password */}
                <div>
                    <label className="block text-[8px] md:text-[24px] font-bold -mb-1 md:pl-2">Password</label>
                    <input type="text" className="bg-[#D9D9D9] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#D9D9D9] outline-none text-[8px] md:text-[24px] placeholder:text-black font-medium" placeholder="XXX1234" />
                </div>
            </div>

            <div className="h-2 md:h-2" />

            <div className="flex justify-end md:mt-3 mt-6">
                <button className="flex items-center md:gap-2 gap-2  hover:bg-[#0f1f1a] text-black hover:text-white  md:py-3 py-1 rounded-md text-[6px] md:text-lg font-normal italic transition">
                    Save
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
                        alt="Save Icon"
                        className="md:w-11 md:h-11 h-3 w-3"
                    />
                </button>
            </div>

            <div>
                <h2 className="text-[8px] md:text-[24px] font-bold text-[#03897B] md:mt-2 ">
                    <span className="text-[#979797]">Section 2 : </span>MEMBERS / DIRECTORS / TRUSTEES/ PARTNERS
                </h2>
                <div className="grid grid-cols-3 gap-2 md:gap-2 md:mt-6">

                    {/* Column Headings */}
                    {["Name", "ID/ Reg Number", "Designation"].map((heading, idx) => (
                        <div key={`head-${idx}`} className="text-[8px] md:text-[24px] font-bold md:-mb-3 text-black">
                            {heading}
                        </div>
                    ))}

                    {/* Input Rows */}
                    {Array(7).fill(0).map((_, rowIdx) => (
                        <>
                            <input
                                key={`name-${rowIdx}`}
                                type="text"
                                className="bg-[#D9D9D9] w-full h-[20px] md:h-[71px] px-2 md:px-4 rounded-[5px] border-[#D9D9D9] outline-none text-[8px] md:text-[24px] placeholder:text-black font-medium"
                                placeholder="Lewis Chauke"
                            />
                            <input
                                key={`id-${rowIdx}`}
                                type="text"
                                className="bg-[#D9D9D9] w-full h-[20px] md:h-[71px] px-2 md:px-4 rounded-[5px] border-[#D9D9D9] outline-none text-[8px] md:text-[24px] placeholder:text-black font-medium"
                                placeholder="912345876"
                            />
                            <input
                                key={`designation-${rowIdx}`}
                                type="text"
                                className="bg-[#D9D9D9] w-full h-[20px] md:h-[71px] px-2 md:px-4 rounded-[5px] border-[#D9D9D9] outline-none text-[8px] md:text-[24px] placeholder:text-black font-medium"
                                placeholder="Director"
                            />
                        </>
                    ))}
                </div>
            </div>

            <div className="flex justify-end md:mt-3 mt-4">
                <button className="flex items-center md:gap-2 gap-2  hover:bg-[#0f1f1a] text-black hover:text-white  md:py-3 py-1 rounded-md text-[6px] md:text-lg font-normal italic transition">
                    Save
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
                        alt="Save Icon"
                        className="md:w-11 md:h-11 h-3 w-3"
                    />
                </button>
            </div>
        </div>
    )
}

export default Section2
